import * as types from './types';

const initState = {
  status: 'IDLE',
  isConnected: false,
  roles: [],
};

type AuthAction = {
  type: typeof types[keyof typeof types];
  payload?: Partial<types.AuthState>;
};

export default function rolesReducer(state = initState, action: AuthAction) {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_ROLE_REQUEST:
      return { ...state, status: 'LOADING' };
    case types.FETCH_ROLE_SUCCEEDED:
      return {
        ...state,
        status: 'SUCCEEDED',
        isConnected: true,
        ...payload
      };
    case types.FETCH_ROLE_FAILED:
      return {
        ...state,
        status: 'FAILED'
      };
    default:
      return state;
  }
}
